export default __webpack_public_path__ + "static/media/semantic-version.d4b4e78b.md";